<template>
  <el-row  class="bg" style="height: 100%;width:100%" >
    <el-col :span="8">&nbsp;</el-col>
    <el-col :span="8" style="height:100%;">
      <el-row></el-row>
      <el-row style="margin-top:50%">
    <div style="width:30rem;
                  height:29rem;
                  border-radius:20px;
                  background-color: rgba(255,255,255,0.7);
                  margin:auto;
                  ">
      <el-row>
        <el-col :span="20" :offset="2" style=" font-size: 1.875rem;color: #332C2B;margin-top:3.59rem"
          >美赑4G网关发货管理平台</el-col>
        </el-row>
        <el-row style="margin-top: 2.36rem;font-size:1.5rem">
        </el-row>
        <el-row :span="20" :offset="2" class="login">
          <el-col :span="20" :offset="2" style="margin-top: 0.625rem">
            <el-input
              placeholder="请输入帐号"
              prefix-icon="el-icon-user"
              v-model="username"
            >
            </el-input
          ></el-col>
          <el-col :span="20" :offset="2" style="margin-top: 0.625rem">
            <el-input
              show-password
              placeholder="请输入密码"
              prefix-icon="el-icon-lock"
              v-model="password"
            >
            </el-input
          ></el-col>
          <el-col :span="20" :offset="2" style="margin-top: 3.16rem;">
            <el-button
              style="width: 100%"
              type="success"
              round
              @click="login()"
            >
              登录</el-button
            ></el-col
          >
        </el-row>

    </div>
      </el-row>
    </el-col>
  </el-row>
</template>

<script>
import Vue from 'vue'
import { hex_md5 } from '../assets/js/md5'

export default {
  name: 'Login',
  data () {
    return {
      username: '',
      password: ''
    }
  },
  mounted: function () {
    this.$store.commit('clearAll')
  },
  methods: {
    login () {
      if (!this.username || !this.password) {
        this.$message({
          showClose: true,
          message: '请输入用户名与密码',
          type: 'error'
        })
        return false
      }
      let self = this
      Vue.axios
        .post('/api/dada/login', {
          username: this.username,
          password: hex_md5(this.password)
        })
        .then((res) => {
          console.log(res)
          if (res.data.errcode == 0) {
            window.localStorage.setItem('sessionid', res.data.msgbody.uuid)
            window.localStorage.setItem(
              'customer',
              JSON.stringify(res.data.msgbody.user)
            )
            self.$router.push({ name: 'Welcome' })
          } else {
            this.$message({
              showClose: true,
              message: res.data.errmsg,
              type: 'error'
            })
          }
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bg {
  width:100%;
  height: 100%;
  background-image: url("../../static/images/bg.jpg");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue